import { memo, useEffect, useState, useRef } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import { Box, Flex, Stack, Text, VStack } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router";
import { HStack, Input, Center, AspectRatio, Button, Image, Table, Container, Wrap, Float, Drawer, CloseButton, Skeleton, SkeletonText, Separator } from "@chakra-ui/react"
import { LuSearch, LuShoppingCart, LuMessageCircle, LuShare2, LuCopy } from "react-icons/lu"
import { Heading } from "@chakra-ui/react"


import { Field } from "@/components/ui/field"
import Slider from "react-slick";
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"

import _ from "lodash"
import { useStore } from "contexts/store";
import BottomSheet from "components/bottom-sheet"
const ShareProduct = ({ open, id, onOpenChange }) => {

    const { user } = useAuth();

    const { copyText } = useApp();
    const { store } = useStore();

    const copyProductShareLink = () => {
        copyText(`${store.web.full_url}?ref=${user.id}`)

    }


    return (
        <div>
            <BottomSheet open={open} onOpenChange={(e) => onOpenChange(e.open)} title="Chia sẻ link - nhận hoa hồng ngay!">
                <Center>
                    <VStack>


                     
                        <Text>Copy link này, gửi cho bạn bè hoặc đăng lên Facebook, Zalo - mỗi đơn đặt hàng là bạn có hoa hồng liền đó!</Text>
                        <Button onClick={copyProductShareLink}><LuCopy></LuCopy> Copy link</Button>
                    </VStack>
                </Center>
            </BottomSheet>



        </div>
    )
}

export default memo(ShareProduct)